// @flow

import LocationsModal from "./LocationsModal"

export default LocationsModal



// WEBPACK FOOTER //
// ./src/Kiosk/LocationsModal/index.js